var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 11.8252V15.6752C14.6693 18.8835 13.3859 20.1668 10.1776 20.1668H6.3276C3.11927 20.1668 1.83594 18.8835 1.83594 15.6752V11.8252C1.83594 8.61683 3.11927 7.3335 6.3276 7.3335H10.1776C13.3859 7.3335 14.6693 8.61683 14.6693 11.8252Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1693 6.32516V10.1752C20.1693 13.3835 18.8859 14.6668 15.6776 14.6668H14.6693V11.8252C14.6693 8.61683 13.3859 7.3335 10.1776 7.3335H7.33594V6.32516C7.33594 3.11683 8.61927 1.8335 11.8276 1.8335H15.6776C18.8859 1.8335 20.1693 3.11683 20.1693 6.32516Z",
    stroke: "white",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b7cb885a38a95b88aaae8bb4205a00fa.svg";
export { ForwardRef as ReactComponent };